<mat-card class="cardWithShadow theme-card">
 
    <mat-card-content class="b-t-1">
         @if(api_ui){
            <div><app-api-ui-response [type]="'nearby_apidata'"></app-api-ui-response></div>
        }
        @else{
        <app-api-title [apiMethod]="HTTPMethod.GET" [url]="api_demo"></app-api-title>
        <div class="d-flex align-items-center justify-content-between">
            <h2 class="f-w-500">Headers</h2>
            <a (click)="api_ui = true" routerLinkActive="router-link-active"  mat-flat-button color="primary" class="w-50" >Try it out</a>
        </div>
         <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="w-100">
                <!-- key Column -->
                <ng-container matColumnDef="key">
                    <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                        Key
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-body-1">
                        <span class="f-s-14">{{ element.key }}</span>
                    </td>
                </ng-container>

                <!-- value Column -->
                <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                        Value
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-body-1">
                        <span class="f-s-14">{{ element.value }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="required">
                    <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                        Required
                    </th>
                    <td mat-cell *matCellDef="let element" class="mat-body-1">
                        <span class="f-s-14">{{ element.required }}</span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        </div>
        <div class="m-b-2">
            <!-- <h2 class="f-w-500">Property Valuetion API</h2> -->
            <div class="est-js-code">
                <pre>{{api_demo}}</pre>
            </div>
            <p class="m-t-1">This API is used to get the details of AVM data</p>
        </div>
        <div class="m-b-2">
            <h2 class="f-w-500">Parameter</h2>
            <div class="table-responsive">
                <table mat-table [dataSource]="QueryDataSource" class="w-100">
                    <!-- key Column -->
                    <ng-container matColumnDef="param">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Query Param
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.param }}</span>
                        </td>
                    </ng-container>
    
                    <!-- value Column -->
                    <ng-container matColumnDef="value">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Value
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.value }}</span>
                             @if (element?.code) {
                                <div>
                                    <pre><code>{{element?.code}}</code></pre>
                                </div>
                            }
                        </td>
                    </ng-container>

                    <!-- value Column -->
                    <ng-container matColumnDef="required">
                        <th mat-header-cell *matHeaderCellDef class="f-w-500 mat-subtitle-1 f-s-16">
                            Required
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-body-1">
                            <span class="f-s-14">{{ element.required }}</span>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="QueryColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: QueryColumns"></tr>
                </table>
            </div>
        </div>
        <div class="m-b-2">
            <h2 class="f-w-500">Example API Response</h2>
            <div class="est-js-code">
                <pre><code>{{api_response}}</code></pre>
            </div>
        </div>
    }
    </mat-card-content>
</mat-card>